import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e670504"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-form__title" }, " Войти ", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-form__text" }, " Email ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "login-form__text" }, " Пароль ", -1 /* HOISTED */))
const _hoisted_5 = { class: "login-form__help" }

import pInput from '../../common/pInput/pInput.vue'
import pButton from '../../common/pButton/pButton.vue'
import { Ref, ref } from 'vue'
import { useAuthPopup } from './../store/authPopup'
import LoginFormData from "@/authSection/types/LoginFormData";
import api from "../api/api";
import { AxiosError } from "axios";
import { useClientStore } from "@/authSection/store/clientStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const authPopupStore = useAuthPopup()
const clientStore = useClientStore()
const loginFormData: Ref<LoginFormData> = ref({
  email: '',
  password: '',
})

function setEmail(event: Event) {
  loginFormData.value.email = (event.target as HTMLInputElement).value
}

function setPassword(event: Event) {
  loginFormData.value.password = (event.target as HTMLInputElement).value
}

async function sendRequest() {
  try {
    await api.loginClient(loginFormData.value)
    authPopupStore.visible = false
    clientStore.isAuth = true
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      if (e.response?.status === 404) {
        window.showNotification('Неверный логин или пароль!', 'warning')
      }
    } else {
      window.showNotification('Произошла ошибка!', 'error')
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(pInput, {
      value: loginFormData.value.email,
      placeholder: 'Введите вашу почту',
      onInput: setEmail
    }, null, 8 /* PROPS */, ["value"]),
    _hoisted_4,
    _createVNode(pInput, {
      value: loginFormData.value.password,
      placeholder: 'Придумайте пароль',
      type: "password",
      onInput: setPassword
    }, null, 8 /* PROPS */, ["value"]),
    _createVNode(pButton, {
      class: "login-form__login",
      onClick: sendRequest
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Войти ")
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("button", {
      class: "login-form__recovery",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(authPopupStore).openRecoveryForm && _unref(authPopupStore).openRecoveryForm(...args)))
    }, " Забыли пароль "),
    _createElementVNode("span", _hoisted_5, [
      _createTextVNode(" У вас нет учетной записи? "),
      _createElementVNode("span", {
        class: "login-form__sign",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(authPopupStore).openLoginForm && _unref(authPopupStore).openLoginForm(...args)))
      }, " Регистрация ")
    ])
  ]))
}
}

})